import React from 'react';
import { cx } from '@/ui/utils/cx';

export type CollapseChevronProps = {
  /** Whether the parent section is expanded (chevron points up when true). */
  expanded: boolean;
  className?: string;
};

/** Shared expand/collapse indicator — collapsed points down, expanded points up. */
export default function CollapseChevron({ expanded, className }: CollapseChevronProps) {
  return (
    <span
      className={cx('collapsible-panel__chevron', className)}
      data-expanded={expanded ? 'true' : 'false'}
      aria-hidden
    />
  );
}
